const catalogValidation = function () {
	const catalogCheck = document.getElementById("CatalogCheckbox");
	const hiddenInput = document.getElementById("CatalogSubscribe");
	
	const init = () => {
		if(catalogCheck && hiddenInput){
			catalogCheck.checked = true;
			hiddenInput.value = "true";

			catalogCheck.addEventListener('change', updateInputValue);
		}
	};
	
	const updateInputValue = (e) =>{
		if(hiddenInput && hiddenInput.value == "true") hiddenInput.value = "false";
		else if(hiddenInput) hiddenInput.value = "true";
	};
	
	return{
		Init: init
	};
};

(async () =>{
	const catalogVal = new catalogValidation();
	catalogVal.Init();
})();